import React, {useCallback, useEffect, useMemo, useState} from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { useSpotContext } from '../context/SpotProvider';
import { Button } from './Button';
import { FaMap } from 'react-icons/fa';
import { TfiViewListAlt } from "react-icons/tfi";
import useAuth from '../hooks/useAuth';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { toast } from 'react-toastify';
import { TbArrowBigRightLines } from "react-icons/tb";
import { PiArrowFatLineRight } from "react-icons/pi";
import { PiArrowFatLineLeft } from "react-icons/pi";


const SPOT_STATUS_LOCKED = process.env.REACT_APP_SPOT_STATUS_LOCKED;
const SPOT_STATUS_FREE = process.env.REACT_APP_SPOT_STATUS_FREE;
const SPOT_STATUS_PREORDERED = process.env.REACT_APP_SPOT_STATUS_PREORDERED;
const SPOT_STATUS_ORDERED = process.env.REACT_APP_SPOT_STATUS_ORDERED;
const SPOT_STATUS_INVOICED = process.env.REACT_APP_SPOT_STATUS_INVOICED;
const SPOT_STATUS_PAYED = process.env.REACT_APP_SPOT_STATUS_PAYED;
const LOCK_TIMEOUT = process.env.REACT_APP_SPOT_LOCK_TIMEOUT_SEC;

//export const SpotMenu = ({count_kaikki, count_vapaa, count_valittu, count_omat, time, showSpots, setShowSpots}) => {                                          
//

export const SpotMenu = ({showSpots, setShowSpots, sizeFilter, setSizeFilter, isMapView=false}) => {   
    //const [showSpots, setShowSpots] = useState('Kaikki');


    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [totalSpotPrice, setTotalSpotPrice] = useState(0);
    const [totalElectricityPrice, setTotalElectricityPrice] = useState(0);
    const [sizes, setSizes] = useState(null);
    const {spots, unlockSpot} = useSpotContext();                                       
    const navigate = useNavigate();    
    const {auth} = useAuth();

    const count_kaikki = useMemo(() => spots?.length, [spots]);
    //const count_omat = 0;
    //const count_valittu = 0;
    //const count_vapaa = 0;
    //const time = 0;
    
      const count_vapaa = spots.filter(spot => spot.status === SPOT_STATUS_FREE || spot.status === SPOT_STATUS_LOCKED).length;
      const count_ennakko = spots.filter(spot => spot.status === SPOT_STATUS_PREORDERED).length;
      const count_varattu = spots.filter(spot => spot.status === SPOT_STATUS_ORDERED || spot.status === SPOT_STATUS_INVOICED || spot.status === "Maksu paikalla").length;
      const count_vahvistetut = spots.filter(spot => spot.status === SPOT_STATUS_PAYED).length;
      let count_valittu = 0;
      let count_omat = 0;
      let time = -1;                     

     if(auth.user) {
        const valitut = spots.filter(spot => auth.user?.userID === spot.userID && ((spot.status === SPOT_STATUS_LOCKED) || (spot.status === SPOT_STATUS_PREORDERED)));
        count_valittu = valitut.length;
        const omat = spots.filter(spot => spot.userID === auth.user?.userID);
        count_omat = omat.length;
    
        if(count_valittu > 0) {
          const mylocked = spots.filter(spot => auth.user?.userID === spot.userID && (spot.status === SPOT_STATUS_LOCKED));
          if(mylocked.length > 0) {
            mylocked.forEach(spot => {
              if(spot.locked === null && time === -1) {              
                time = Date.now();              
              }
              else if(time === -1 || new Date(spot.locked).getTime() > time) {
                time = new Date(spot.locked).getTime();              
              }
            });
            time = time + LOCK_TIMEOUT*1000;            
          }


           

        } 
      }

      if(!sizes && spots && spots.length > 0) {
        const sizeCounts = {};
        
        spots.forEach(spot => {
          if (sizeCounts[spot.size]) {
            sizeCounts[spot.size]++;
          } else {
            sizeCounts[spot.size] = 1;
          } 
        })

        const sortedSizes = Object.keys(sizeCounts).sort();

        // Create an ordered list of sizes and their counts
        const orderedSizeCounts = sortedSizes.map(size => ({
          size,
          count: sizeCounts[size]
        }));

        setSizes(orderedSizeCounts);
      }
    
      console.log(new Date());

    useEffect(() => {

      if(auth?.user && spots) {
        const valitut = spots.filter(spot => auth.user?.userID === spot.userID && ((spot.status === SPOT_STATUS_LOCKED) || (spot.status === SPOT_STATUS_PREORDERED)));
        let total = valitut.reduce((total, spot) => (total) + parseInt(spot.fixedPrice ?? spot.prize, 10), 0);

        total = total + valitut.reduce((total, spot) => 
              total + (spot.fixedPrice ? 0 : (spot.electricityType === "230V" || spot.electricityType === "400V") ? 15 : 0),0);

        setTotalSpotPrice(total);
      }
        
    }, [count_valittu, spots]); 
      

    useEffect(() => {
      if(count_valittu === 0 && showSpots === "Valitut") {
            setShowSpots("Vapaa");
        }
    }, [count_valittu, count_omat, showSpots, setShowSpots]);  

    const gotoPage = useCallback((linkName, state = undefined) => {
      navigate(linkName, state ? { state } : undefined);
    }, [navigate])

    const handleChange = (event) => {
        setShowSpots(event.target.value);
        
        if(count_valittu === 0 && event.target.value === "Valitut") {
          toast.warn("Et ole valinnut vielä yhtään paikkaa.");
        }

        if(auth?.user && count_omat === 0 && event.target.value === "Omat") {
          toast.info("Sinulla ei ole vielä omia varauksia.");
        }
    };

    const unlockAll = () => {
      console.log("SpotMenu - unlockAll");
      spots.filter(spot => spot.status === SPOT_STATUS_LOCKED && spot.userID === auth.user.userID).forEach(spot => {
        unlockSpot(spot,SPOT_STATUS_FREE);
      }) 
    }

      // Handle checkbox change
  const handleCheckboxChange = (size) => {
    setSizeFilter((prevSizeFilter) => {
      if (prevSizeFilter && prevSizeFilter.includes(size)) {
        // Remove size from selected if already selected
        return prevSizeFilter.filter((item) => item !== size);
      } else {
        // Add size to selected
        return [...prevSizeFilter, size];
      }
    });
  };
           

  return (
    <>

      {showFilterMenu ?
        (<>
        <div className='fixed right-0 top-32 z-30 flex max-h-[calc(100vh-10rem)] w-72 flex-col overflow-y-auto rounded-l-2xl border border-slate-200 bg-[linear-gradient(180deg,#0f2f5c_0%,#174a8d_58%,#0c3d74_100%)] px-4 py-4 text-white shadow-[-12px_12px_32px_rgba(15,23,42,0.22)]'>  
          
            <button type="button" onClick={() => setShowFilterMenu(false)} className="ml-auto flex flex-row items-center text-sm font-semibold text-white/80 transition hover:text-white"><PiArrowFatLineRight className="mr-2 text-sm"/>Sulje</button> 
            <div>
            <FormControl className="mt-4 rounded-2xl border border-white/12 bg-white/10 p-4">      
              <span className="mb-2 block text-xs font-bold uppercase tracking-[0.22em] text-blue-100">Tila</span>
              <RadioGroup
                column
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={showSpots}
                onChange={handleChange}
                className="space-y-0" 
                
              >
                <FormControlLabel key="c1" value="Kaikki" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Kaikki ({count_kaikki})</span>} className="py-0 mt-0 mb-0" />
                <FormControlLabel key="c6" value="Ennakko" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Ennakko ({count_ennakko})</span>} className="mb-0" />
                <FormControlLabel key="c2" value="Varattu" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Varattu ({count_varattu})</span>} className="mb-0" />
                <FormControlLabel key="c7" value="Vahvistettu" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Vahvistettu ({count_vahvistetut})</span>} className="mb-0" />
                <FormControlLabel key="c3" value="Vapaa" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Vapaa ({count_vapaa})</span>} className="mb-0" />
                {count_valittu > 0 ?
                <FormControlLabel key="c4" value="Valitut" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Vahvistamattomat ({count_valittu})</span>}/>
                : null }
                {auth?.user ?
                <FormControlLabel key="c5" value="Omat" control={<Radio sx={{ transform: "scale(0.6)", height: 24, color: "white", '&.Mui-checked': { color: "#f8fafc" } }} />} label={<span className="text-xs">Omat varaukset ({count_omat})</span>}/>
                : null}
              </RadioGroup>
            </FormControl>  

            <FormControl className="mt-4 rounded-2xl border border-white/12 bg-white/10 p-4"> 
              <span className="mt-0 block text-xs font-bold uppercase tracking-[0.22em] text-blue-100">Koko</span>  
              <div className="flex flex-col space-y-0"> {/* Adjust spacing */}

              { sizes && sizes.map((size,index) => {
                  return <FormControlLabel 
                  key={index} 
                  control={<Checkbox 
                    checked={sizeFilter && sizeFilter.includes(size)}
                    onChange={() => handleCheckboxChange(size)}
                    sx={{ 
                    transform: "scale(0.6)", 
                    color: "white",
                    height: 24,
                    '&.Mui-checked': { color: "#f8fafc" }  
                  }} />} 
                  label={<span className="text-xs text-white">{size.size} ({size.count})</span>}
                  sx={{ marginBottom: 0 }}
                />  
              })}  
                  
              </div>
            </FormControl>
          </div>
        </div></>)
      : <div onClick={() => setShowFilterMenu(true)} className="fixed right-0 top-32 z-30 flex cursor-pointer flex-row rounded-l-2xl border border-r-0 border-slate-200 bg-white/95 px-1 py-3 text-sm font-semibold text-slate-700 shadow-[-8px_8px_22px_rgba(15,23,42,0.14)] transition hover:bg-blue-50 hover:text-blue-800 [writing-mode:vertical-rl]">
        <span><PiArrowFatLineLeft className="mb-2 mr-1 text-sm ml-0 px-0"/></span> 
        <span>Suodata</span></div>

      
      }
    
    
    <div className='fixed top-14 left-0 right-0 z-30 flex flex-wrap items-center gap-2 border-b border-slate-200/70 bg-white/94 px-4 py-2 shadow-[0_12px_30px_rgba(15,23,42,0.1)] backdrop-blur md:px-6'>
      {auth?.user &&
        <div className='flex flex-col leading-tight text-slate-900'>          
          <span className='text-[10px] font-bold uppercase tracking-[0.24em] text-blue-700/80'>Yhteishinta</span><span className='text-lg font-black text-slate-900'>{totalSpotPrice} €</span>          
        </div>
      }      
    
    <div className='ml-auto flex flex-row flex-wrap items-center justify-end gap-2'>
    {auth?.user ?
      <button
        type="button"
        onClick={() => gotoPage('/myyntipaikat-lista', { initialShowSpots: 'Omat' })}
        className="inline-flex shrink-0 items-center gap-1 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-bold text-emerald-900 shadow-sm transition hover:border-emerald-300 hover:bg-emerald-100"
      >
        Omat varaukset
      </button>
      : null}
    { isMapView ?     
    <Link to="/myyntipaikat-lista" className="inline-flex shrink-0 items-center gap-1 rounded-xl border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm font-bold text-blue-900 shadow-sm transition hover:border-blue-300 hover:bg-blue-100"><TfiViewListAlt className="inline" /> Lista</Link>
    : <Link to="/myyntipaikat-kartta" className="inline-flex shrink-0 items-center gap-1 rounded-xl border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm font-bold text-blue-900 shadow-sm transition hover:border-blue-300 hover:bg-blue-100"><FaMap /> Kartta</Link>
    }
    {auth.user && count_valittu > 0 ? (
        !time || time === -1 ? (
          <Button name="Vahvista..." type="PRIMARY" action={() => gotoPage("/vahvista-sahko")} className="mb-0 rounded-xl border border-blue-600 bg-blue-600 px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-blue-700" />
        ) : (
          <Button
            name="Vahvista..."
            timer={time}
            timerCallback={() => unlockAll()}
            type="PRIMARY"
            action={() => gotoPage("/vahvista-sahko")}
            className="mb-0 rounded-xl border border-blue-600 bg-blue-600 px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-blue-700"
          />
        )
      ) : (
        <Button name="Vahvista..." type="DISABLED" className="mb-0 rounded-xl border border-slate-200 bg-slate-100 px-4 py-2 text-sm font-bold text-slate-400 shadow-sm" />
      )}
      </div>
    
    </div>
    </>
  )
}


SpotMenu.whyDidYouRender = true;